import React, { Component } from 'react';
import Icon from '../../../../../icons/Icon';
import LanguageUtil from '../../../../../util/LanguageUtil';

class NoAuthComponent extends Component {
  public render() {
    return (
      <div className={'flex flex-col w-full h-full items-center justify-center'}>
        <Icon icon={'no-folder'} size={100} />
        <div className={'px-5 py-5 bg-f-gray mt-5 rounded shadow-sm'}>
          {LanguageUtil.get({ id: 'pages.action.api.authorization.description', defaultMessage: 'This request does not user any authorization.' })}
        </div>
      </div>
    );
  }
}

export default NoAuthComponent;
